import {useEffect, useState} from 'react'
import "./Conditions.css"
import Side from '../sidecontainer/side'
import { getPrivacyPolicy } from '../../HTTP/user';
const POLITIQUE = () => {
  const [policy, setPolicy] = useState(null); // string html
  
    useEffect(() => {
      const fetchPolicy = async () => {
        try {
          const res = await getPrivacyPolicy();
          if (res) {
            setPolicy(res.value);
          }
        }  catch (error) {
          console.error("Erreur lors de la récupération des CGU :", error);
        }
      }
      fetchPolicy();
    }, []);
  
    return (
      <div className='mt-8 py-12 px-4 sm:px-6 lg:px-8 md:max-h-screen md:overflow-y-auto'>
        <div dangerouslySetInnerHTML={{ __html: policy }}></div>
      </div>
    )
}

export default POLITIQUE